import React, {memo, useMemo} from 'react'
import {Space} from 'antd'
import {VStack} from '../../../../../../ui/Stack'
import dayjs from 'dayjs'
import { StagePlanItemI } from '../../../model/types/types'


export const StagePlanItemAppeal: React.FC<StagePlanItemI> = memo((props: StagePlanItemI) => {
  const {date_end, date_start, name} = props

  const formatDateStart = useMemo<null | string>(
    () => date_start ? dayjs(date_start).format('DD.MM.YYYY') : null,
    [date_start],
  )

  const formatDateEnd = useMemo<null | string>(
    () => date_end ? dayjs(date_end).format('DD.MM.YYYY') : null,
    [date_end],
  )

  return (
    <VStack align={'start'} style={{paddingBottom: '16px'}}>
      <Space size={4}>
        <span>{name}{formatDateStart && ':'}</span>
        <span style={{fontWeight: 'bold'}}>
          {formatDateStart && `${formatDateStart}`}
          {formatDateEnd && ` - ${formatDateEnd}`}
        </span>
      </Space>
    </VStack>
  )
})
